// import React, { useState } from "react";
// import { useDispatch, useSelector } from "react-redux";
// import { loginStart, loginSuccess, loginFailure } from "../../store/authSlice";
// import { useFormik } from "formik";
// import * as Yup from "yup";
// import { useNavigate } from "react-router-dom";
// import {
//   Box,
//   Typography,
//   TextField,
//   Button,
//   CircularProgress,
//   Link,
// } from "@mui/material";
// import { API_BASE_URL } from "../../config";
// import { SnackBarComponent } from "../../Components/snackBar/snackBar";
// import { CaptchaComponent } from "../../Components/captcha/captchaComponent";
// import { useTranslation } from "react-i18next";

// export const Login = ({ handleShowRegister, handleShowForgot }) => {
//   const dispatch = useDispatch();
//   const navigate = useNavigate();
//   const loading = useSelector((state) => state.auth.loading);
//   const { t } = useTranslation();

//   const [snackbar, setSnackbar] = useState({
//     open: false,
//     message: "",
//     severity: "success",
//   });
//   const [captchaKey, setCaptchaKey] = useState("");

//   const formik = useFormik({
//     initialValues: { email: "", password: "", captcha_value: "" },
//     validationSchema: Yup.object({
//       email: Yup.string()
//         .email(t("signin.errors.invalidEmail"))
//         .required(t("signin.errors.required")),
//       password: Yup.string().required(t("signin.errors.required")),
//       captcha_value: Yup.string().required(t("signin.errors.captchaRequired")),
//     }),
//     onSubmit: async (values) => {
//       dispatch(loginStart());
//       try {
//         const response = await fetch(`${API_BASE_URL}/auth/signin/`, {
//           method: "POST",
//           headers: { "Content-Type": "application/json" },
//           body: JSON.stringify({
//             email: values.email,
//             password: values.password,
//             captcha_key: captchaKey,
//             captcha_value: values.captcha_value,
//           }),
//         });
//         const data = await response.json();

//         // FIXED ERROR LOGIC ONLY
//         if (!response.ok) {
//           let apiError = data.error || data.email?.[0] || data.password?.[0] || data.message || t("signin.errors.defaultFail");
//           if (typeof apiError !== 'string') {
//             apiError = Object.values(apiError).flat().join(', ') || t("signin.errors.defaultFail");
//           }
//           throw new Error(apiError);
//         }

//         if (!data.access_token || !data.refresh_token) {
//           throw new Error(data.message || t("signin.errors.defaultFail"));
//         }

//         dispatch(
//           loginSuccess({
//             access_token: data.access_token,
//             refresh_token: data.refresh_token,
//             role: data.roles,
//           })
//         );

//         setSnackbar({
//           open: true,
//           message: t("signin.success"),
//           severity: "success",
//         });
//         setTimeout(() => navigate("/claim-mgmt"), 1000);
//       } catch (err) {
//         const errMsg = err.message || t("signin.errors.defaultFail");
//         dispatch(loginFailure(errMsg));
//         setSnackbar({ open: true, message: errMsg, severity: "error" });
//       }
//     },
//   });

//   const handleCloseSnackbar = (_, reason) => {
//     if (reason === "clickaway") return;
//     setSnackbar((prev) => ({ ...prev, open: false }));
//   };

//   return (
//     <>
//       <Typography variant="h5" fontWeight="bold" gutterBottom textAlign="center">
//         {t("signin.heading")}
//       </Typography>

//       <Box
//         component="form"
//         onSubmit={formik.handleSubmit}
//         sx={{ display: "flex", flexDirection: "column", gap: 2 }}
//       >
//         <TextField
//           label={t("signin.fields.email")}
//           name="email"
//           type="email"
//           size="small"
//           value={formik.values.email}
//           onChange={formik.handleChange}
//           onBlur={formik.handleBlur}
//           error={formik.touched.email && Boolean(formik.errors.email)}
//           helperText={formik.touched.email && formik.errors.email}
//           fullWidth
//           required
//         />
//         <TextField
//           label={t("signin.fields.password")}
//           name="password"
//           type="password"
//           size="small"
//           value={formik.values.password}
//           onChange={formik.handleChange}
//           onBlur={formik.handleBlur}
//           error={formik.touched.password && Boolean(formik.errors.password)}
//           helperText={formik.touched.password && formik.errors.password}
//           fullWidth
//           required
//         />

//         {/* Captcha */}
//         <CaptchaComponent
//           onChange={formik.handleChange}
//           setCaptchaKey={setCaptchaKey}
//         />
//         <TextField
//           label={t("signin.fields.captcha")}
//           name="captcha_value"
//           size="small"
//           value={formik.values.captcha_value}
//           onChange={formik.handleChange}
//           onBlur={formik.handleBlur}
//           error={
//             formik.touched.captcha_value && Boolean(formik.errors.captcha_value)
//           }
//           helperText={formik.touched.captcha_value && formik.errors.captcha_value}
//           fullWidth
//           required
//         />

//         <Box sx={{ textAlign: "right" }}>
//           <Link
//             onClick={handleShowForgot}
//             underline="hover"
//             sx={{ cursor: "pointer", fontSize: 14 }}
//           >
//             {t("signin.forgotPassword")}
//           </Link>
//         </Box>

//         <Button
//           type="submit"
//           variant="contained"
//           color="primary"
//           fullWidth
//           disabled={loading}
//           startIcon={loading ? <CircularProgress size={20} /> : null}
//         >
//           {loading ? t("signin.buttons.loggingIn") : t("signin.buttons.login")}
//         </Button>
//       </Box>

//       <Typography variant="body2" align="center" sx={{ mt: 2 }}>
//         {t("signin.noAccount")}{" "}
//         <Link
//           onClick={handleShowRegister}
//           underline="hover"
//           sx={{ cursor: "pointer" }}
//         >
//           {t("signin.registerLink")}
//         </Link>
//       </Typography>

//       {/* Snackbar */}
//       <SnackBarComponent
//         open={snackbar.open}
//         message={snackbar.message}
//         severity={snackbar.severity}
//         onClose={handleCloseSnackbar}
//       />
//     </>
//   );
// };



import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { loginStart, loginSuccess, loginFailure } from "../../store/authSlice";
import { useFormik } from "formik";
import * as Yup from "yup";
import { useNavigate } from "react-router-dom";
import {
  Box,
  Typography,
  TextField,
  Button,
  CircularProgress,
  Link,
} from "@mui/material";
import { API_BASE_URL } from "../../config";
import { SnackBarComponent } from "../../Components/snackBar/snackBar";
import { CaptchaComponent } from "../../Components/captcha/captchaComponent";
import { useTranslation } from "react-i18next";
import { isRoleValid } from "../../api/api";

export const Login = ({ handleShowRegister, handleShowForgot }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const loading = useSelector((state) => state.auth.loading);
  const { t } = useTranslation();

  const [snackbar, setSnackbar] = useState({
    open: false,
    message: "",
    severity: "success",
  });
  const [captchaKey, setCaptchaKey] = useState("");

  const formik = useFormik({
    initialValues: { email: "", password: "", captcha_value: "" },
    validationSchema: Yup.object({
      email: Yup.string()
        .email(t("signin.errors.invalidEmail"))
        .required(t("signin.errors.required")),
      password: Yup.string().required(t("signin.errors.required")),
      captcha_value: Yup.string().required(t("signin.errors.captchaRequired")),
    }),
    onSubmit: async (values) => {
      dispatch(loginStart());
      try {
        const response = await fetch(`${API_BASE_URL}/auth/signin/`, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            email: values.email,
            password: values.password,
            captcha_key: captchaKey,
            captcha_value: values.captcha_value,
          }),
        });
        const data = await response.json();

        // FIXED ERROR LOGIC ONLY
        if (!response.ok) {
          let apiError = data.error || data.email?.[0] || data.password?.[0] || data.message || t("signin.errors.defaultFail");
          if (typeof apiError !== 'string') {
            apiError = Object.values(apiError).flat().join(', ') || t("signin.errors.defaultFail");
          }
          throw new Error(apiError);
        }

        if (!data.access_token || !data.refresh_token) {
          throw new Error(data.message || t("signin.errors.defaultFail"));
        }

        // Confirm the role the backend picked is actually one this user
        // holds, before any cookie or Redux state gets set.
        const requestedRole = Array.isArray(data.roles) ? data.roles[0] : data.roles;
        const roleOk = await isRoleValid(data.access_token, requestedRole);

        if (!roleOk) {
          throw new Error(t("signin.errors.unauthorizedRole") || "Unauthorized role.");
        }

        dispatch(
          loginSuccess({
            access_token: data.access_token,
            refresh_token: data.refresh_token,
            role: data.roles,
          })
        );

        setSnackbar({
          open: true,
          message: t("signin.success"),
          severity: "success",
        });
        setTimeout(() => navigate("/claim-mgmt"), 1000);
      } catch (err) {
        const errMsg = err.message || t("signin.errors.defaultFail");
        dispatch(loginFailure(errMsg));
        setSnackbar({ open: true, message: errMsg, severity: "error" });
      }
    },
  });

  const handleCloseSnackbar = (_, reason) => {
    if (reason === "clickaway") return;
    setSnackbar((prev) => ({ ...prev, open: false }));
  };

  return (
    <>
      <Typography variant="h5" fontWeight="bold" gutterBottom textAlign="center">
        {t("signin.heading")}
      </Typography>

      <Box
        component="form"
        onSubmit={formik.handleSubmit}
        sx={{ display: "flex", flexDirection: "column", gap: 2 }}
      >
        <TextField
          label={t("signin.fields.email")}
          name="email"
          type="email"
          size="small"
          value={formik.values.email}
          onChange={formik.handleChange}
          onBlur={formik.handleBlur}
          error={formik.touched.email && Boolean(formik.errors.email)}
          helperText={formik.touched.email && formik.errors.email}
          fullWidth
          required
        />
        <TextField
          label={t("signin.fields.password")}
          name="password"
          type="password"
          size="small"
          value={formik.values.password}
          onChange={formik.handleChange}
          onBlur={formik.handleBlur}
          error={formik.touched.password && Boolean(formik.errors.password)}
          helperText={formik.touched.password && formik.errors.password}
          fullWidth
          required
        />

        {/* Captcha */}
        <CaptchaComponent
          onChange={formik.handleChange}
          setCaptchaKey={setCaptchaKey}
        />
        <TextField
          label={t("signin.fields.captcha")}
          name="captcha_value"
          size="small"
          value={formik.values.captcha_value}
          onChange={formik.handleChange}
          onBlur={formik.handleBlur}
          error={
            formik.touched.captcha_value && Boolean(formik.errors.captcha_value)
          }
          helperText={formik.touched.captcha_value && formik.errors.captcha_value}
          fullWidth
          required
        />

        <Box sx={{ textAlign: "right" }}>
          <Link
            onClick={handleShowForgot}
            underline="hover"
            sx={{ cursor: "pointer", fontSize: 14 }}
          >
            {t("signin.forgotPassword")}
          </Link>
        </Box>

        <Button
          type="submit"
          variant="contained"
          color="primary"
          fullWidth
          disabled={loading}
          startIcon={loading ? <CircularProgress size={20} /> : null}
        >
          {loading ? t("signin.buttons.loggingIn") : t("signin.buttons.login")}
        </Button>
      </Box>

      <Typography variant="body2" align="center" sx={{ mt: 2 }}>
        {t("signin.noAccount")}{" "}
        <Link
          onClick={handleShowRegister}
          underline="hover"
          sx={{ cursor: "pointer" }}
        >
          {t("signin.registerLink")}
        </Link>
      </Typography>

      {/* Snackbar */}
      <SnackBarComponent
        open={snackbar.open}
        message={snackbar.message}
        severity={snackbar.severity}
        onClose={handleCloseSnackbar}
      />
    </>
  );
};